import { Alert, Box, Button, Snackbar, Typography } from "@mui/material"
import { useState, useEffect, useCallback } from "react";
import { useAtom } from "jotai";
import TableComponent from "../../quality/punchlist/TableComponent";
import { scopeReport } from "../../../shared/constent/constent";
import { DownloadExcelFile } from "../../../shared/Helper";
import settingsAtom from "../../../atoms/settings/SettingsAtom";
import { DownloadIcon } from "lucide-react";
import reportsAtoms, { getScopeList } from "../../../atoms/reports/ReportsAtom";

const ScopeAllocatedPerLaydown = () => {
    const [loader, setLoader] = useState(false);
    const [, setScopeList] = useAtom(getScopeList);
    const [list] = useAtom(reportsAtoms);
    const { scopeData = {} } = list;
    const [initialFilter, setInitialFilter] = useState({})
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 10,
        page: 0,
      });
    const [filters, setFilters] = useState([]);
    const getResult = (data) => {
      return data?.reduce((acc, item) => ({ ...acc, ...item }), {});
    };
    
    const [lists, setList] = useState({
        block: [],
        section:[], 
        row: [],
        laydown: [],
        part_number: [],
        part_description: []
      });
    const [currentFilter, setCurrentFilter] = useState({
      block: [],
      section:[], 
      row: [],
      laydown: [],
      part_number: [],
      part_description: []
    });
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, severity: 'success', message: '' });
    const [colValue, setColValue] = useState([]);
    const [settingsData] = useAtom(settingsAtom)
    const { projectList } = settingsData;
    const currentProject = projectList.find(o => o.id === parseInt(localStorage.getItem("project_id")));
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const filterableColumns = [ "block", "row", "section", "status", "scope", "checkpoint","time_stamp", "laydown", "part_name", "part_description"];


    
    const init = useCallback(async () => {
        setLoader(true)
        const currentValues = getResult(filters);
        try {
            if(filters?.length) {
                await setScopeList({
                    ...currentValues,
                    "page": paginationModel?.page + 1,
                    "page_size": paginationModel?.pageSize,

                })
            } else {
                await setScopeList({
                    "page": paginationModel?.page + 1,
                    "page_size": paginationModel?.pageSize,
                })
            }
        } catch (err) {
            console.error(err)
        } finally {
            setLoader(false)
        }
    }, [setScopeList, paginationModel, filters]);

    useEffect(() => {
        init()
    }, [init]);

    useEffect(() => {
        if (scopeData?.unique_values && filters?.length === 0) {
          setInitialFilter(scopeData.unique_values);
          setList(scopeData.unique_values);
          setCurrentFilter(
            {
              block: [],
              section:[], 
              row: [],
              laydown: [],
              part_number: [],
              part_description: []
            }
        )
        } else if (filters?.length) {
          const filterKeys = filters
                            .map(f => Object.keys(f)[0])
                            .filter((_, index) => index === 0)
      
          const resetFilterValues = filterKeys.reduce((acc, key) => {
            acc[key] = initialFilter[key];
            return acc;
          }, {});

          setList({
            ...scopeData.unique_values,
            ...resetFilterValues,
          });

          setCurrentFilter(scopeData.unique_values)

        }
      }, [scopeData, filters, initialFilter]);

    const handleClearFilter = () => {
        setCurrentFilter(
            {
              block: [],
              section:[], 
              row: [],
              laydown: [],
              part_number: [],
              part_description: []
            }
        )
        setFilters([])
        setList(
            {
              block: [],
              section:[], 
              row: [],
              laydown: [],
              part_number: [],
              part_description: []
            }
        )
        setSelectedRows([])
        setRowSelectionModel([])
    }

    const handleDownload = async () => {
        const data = (scopeData?.data?.data || []).map(row => ({
          ...row,
          id: row.bom_tracker_row_laydown_id, 
        }));
  
        setLoading(true);
        try {
          await DownloadExcelFile(colValue, data, currentProject, setSnackbar, "Scope Report Data")
          setSnackbar({ open: true, message: 'Downloaded Scope Report Data', severity: 'success' });
        } catch (err) {
          setSnackbar({ open: true, severity: 'error', message: 'Error downloading Excel.' });
          console.error(err);
        } finally {
          setLoading(false);
        }
    }

    const data = (scopeData?.data?.data || []).map(row => ({
      ...row,
      id: row.bom_tracker_row_laydown_id, 
    }));

    const pagination = scopeData?.data?.pagination?.total_count || 10;

    return (
        <Box px={4} py={2} mt={1.5}>
            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
            </Snackbar>

           <Box mb={1} sx={{ display:"flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="span" fontSize={22} sx={{ fontWeight: "bold", pb: 2 }}>
                Scope allocated per Laydown report
              </Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                  <Button
                      variant="outlined"
                      startIcon={<DownloadIcon size={18} />}
                      onClick={handleDownload}
                      loading={loading}
                  >
                      Download
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={handleClearFilter}
                    loading={loading}
                  >
                    Clear Filter
                  </Button>
              </Box>
             
          </Box>

            <TableComponent
                data={data} 
                initialColumns={scopeReport}
                count={pagination}
                loader={loader}
                setLoader={setLoader}
                paginationModel={paginationModel} 
                setPaginationModel={setPaginationModel}
                filters={filters}
                setFilters={setFilters}
                initialFilter={initialFilter}
                setPunchlist={setScopeList}
                list={lists} 
                setList={setList}
                currentFilterValue={currentFilter} 
                setCurrentFilterValue={setCurrentFilter}
                colValue={colValue} 
                setColValue={setColValue}
                selectedRows={selectedRows} 
                setSelectedRows = {setSelectedRows}
                rowSelectionModel={rowSelectionModel} 
                setRowSelectionModel={setRowSelectionModel}
                enableSelection = {true}
                filterableColumns={filterableColumns}
            />
        </Box>
      
    )
}

export default ScopeAllocatedPerLaydown;